import { gql } from "@apollo/client";

export const QUERY_CASES = gql`
  query cases($search: String, $status: String, $broker: String, $offset: Int) {
    cases {
      cases(
        search: $search
        status: $status
        broker: $broker
        pagination: { offset: $offset, limit: 20 }
      ) {
        totalCount
        pageInfo {
          limit
          offset
        }
        results {
          uuid
          reference
          status
          statusDisplay
          createdOn
          applicantNames
          broker
        }
      }
    }
    options_status: __type(name: "CaseStatusType") {
      options: enumValues {
        value: name
        title: description
      }
    }
  }
`;

export const QUERY_CASE_DETAIL = gql`
  query case($uuid: UUID!) {
    cases {
      case(uuid: $uuid) {
        uuid
        reference
        status
        state
        statusDisplay
        createdOn
        broker
        applicantNames
        canSubmitApplication
        applications {
          uuid
          reference
          status
          statusDisplay
          createdOn
          applicationDate
          downloadUrl
          isLatestSubmission
          hasDebtsToSettle
        }
        illustrations {
          uuid
          reference
          createdOn
          downloadUrl
          productReference
          createdBySubmission
        }
      }
    }
  }
`;

export const QUERY_CASE_DOCUMENTS = gql`
  query CaseDocuments($caseId: UUID!) {
    data: cases {
      case(uuid: $caseId) {
        reference
        uuid
        status
        applications {
          uuid
          reference
          applicationDate
          isLatestSubmission
        }
        documents {
          uuid
          kind
          kindLabel
          name
          createdOn
        }
      }
    }
  }
`;

export const QUERY_CASE_APPLICATION_SUMMARY = gql`
  query CaseApplicationSummary($uuid: String!) {
    data: applications {
      application(uuid: $uuid) {
        uuid
        broker {
          feeAmount
          brokerFeeAddedToLoan
        }
        applicants {
          uuid
          forename
          surname
        }
        loan {
          loanAmount
          loanTermMonths
          purposeOfLoan
        }
      }
    }
  }
`;

export const QUERY_CASE_TASKS = gql`
  query CaseTasks($uuid: UUID!) {
    cases {
      case(uuid: $uuid) {
        uuid
        tasks {
          uuid
          kind
          status
          title
          context
          createdOn
          resolvedAt
        }
      }
    }
  }
`;
